import { useContext, useState } from 'react';
import { businessApiRoute, post } from './Api';
import * as Toast from './Toast.js';
import { ErrorContext } from './ErrorContext';
import usePostApi from './usePostApi.js';

export default function (route, opts) {
    return usePostApi(businessApiRoute(route), opts);
}
